var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5787_335",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5787_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6704 7.84619L14.0416 13.3661L14.2259 16.1405C14.2279 16.4259 14.2726 16.7093 14.3588 16.9817C14.5814 17.5105 15.1168 17.8465 15.6994 17.8231L24.5756 17.2424C24.96 17.2361 25.3312 17.3799 25.6075 17.6421C25.8378 17.8607 25.9864 18.1465 26.0334 18.454L26.0491 18.6407C25.6818 23.7269 21.9462 27.9693 16.8704 29.0644C11.7946 30.1595 6.58971 27.8461 4.08151 23.3803C3.35842 22.0828 2.90677 20.6568 2.75307 19.1857C2.68887 18.7503 2.66061 18.3104 2.66854 17.8704C2.66061 12.4174 6.54386 7.70302 11.9797 6.5665C12.6339 6.46462 13.2753 6.81096 13.5376 7.40778C13.6055 7.54599 13.6503 7.69402 13.6704 7.84619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.3335 13.0834L29.3241 13.1268L29.2972 13.19L29.3009 13.3635C29.2871 13.5933 29.1983 13.8143 29.0455 13.993C28.8861 14.179 28.6685 14.3057 28.4289 14.3549L28.2828 14.3749L18.0417 15.0385C17.7011 15.0721 17.3619 14.9622 17.1087 14.7363C16.8975 14.5479 16.7625 14.2938 16.7244 14.0199L16.0371 3.79374C16.0251 3.75916 16.0251 3.72168 16.0371 3.6871C16.0464 3.40522 16.1705 3.13878 16.3816 2.9473C16.5925 2.75582 16.8731 2.65526 17.1601 2.66808C23.24 2.82276 28.3499 7.19471 29.3335 13.0834Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.7fd89989e9bd8bdf0b258260de98106c.svg";
export { ForwardRef as ReactComponent };